import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';

import Select from 'react-select';
import moment from 'moment';
import Rating from "react-rating";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { Pagination } from 'antd';

import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from '../common_component/PageError.js';
import { getCookie } from '../common_component/cookie.js';
import PageLoader from "../common_component/PageLoader.js";

function EcommerceOrderReviewList() {
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme();
    const [ecommerceOrderReviewListApiState, setEcommerceOrderReviewListApiState] = useState(false)

    const [reviews, setReviews] = useState([]);
    const [averageRating, setAverageRating] = useState(0);
    const [starCount, setStarCount] = useState([]);
    const [statusType, setStatusType] = useState("All");
    //const statusTypeArray = ["Vendor", "Manufacturer"];
    const statusTypeArray = [];

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchValue, setSearchValue] = useState(null)
    const [startDate, setStartDate] = useState(moment.utc().subtract(30, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))

    const apiController = useRef(new AbortController());

    const daterange_picker_ref = useRef();

    var page_name = "ecommerce-order-review-list";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    async function getEcommerceOrderReviewList(cp, rpp, search_v, sd, ed) {
        try {
            if (ecommerceOrderReviewListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setEcommerceOrderReviewListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-order-review`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "status_type": statusType, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "start_date": sd, "end_date": ed, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get ecommerce order list api error"

            const allReviews = body.data.list;
            setReviews(allReviews);
            const totalRating = allReviews.reduce((sum, review) => sum + review.rating, 0);
            setAverageRating(totalRating / allReviews.length);
            const starDistribution = [5, 4, 3, 2, 1].map((stars) => ({
                stars,
                percentage:
                    (allReviews.filter((review) => review.rating === stars).length /
                        allReviews.length) *
                    100,
            }));
            setStarCount(starDistribution);
            setListCount(body.data.count);
            setEcommerceOrderReviewListApiState(false);
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getEcommerceOrderReviewList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType);
            Promise.all([p1])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)

                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getEcommerceOrderReviewList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType)
        }
    }, [currentPage, rowsPerPage, searchValue, startDate, endDate, statusType])


    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Order Review List</h1>
                </div>
                <div>
                    {state === 1 ?
                        <>
                            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                                {reviews.length > 0 &&
                                    <div className="card card-flush p-4">
                                        <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
                                            <h4 className="mb-0">Average Rating</h4>
                                            <h1 className="m-0">{averageRating.toFixed(1)}</h1>
                                            <span className="text-warning ml-2">{Array.from({ length: 5 }, (_, i) => (<i key={i} className={`fas fa-star ${i < Math.round(averageRating) ? 'text-warning' : 'text-muted'}`}></i>))}</span>
                                            <span className="text-muted">{reviews.length} reviews</span>
                                        </div>

                                        {/* Rating Distribution */}
                                        <div>
                                            {starCount.map((rating) => (
                                                <div key={rating.stars} className="mb-3">
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            {rating.stars} Stars
                                                        </div>
                                                        <div>{rating.percentage.toFixed(1)}%</div>
                                                    </div>
                                                    <div className="progress" style={{ height: '10px' }}>
                                                        <div
                                                            className={`progress-bar bg-${rating.stars >= 4
                                                                ? 'success'
                                                                : rating.stars === 3
                                                                    ? 'warning'
                                                                    : 'danger'
                                                                }`}
                                                            role="progressbar"
                                                            style={{ width: `${rating.percentage}%` }}
                                                        ></div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>}

                                <div className="card card-flush py-4">
                                    <div className="card-header">
                                        <div className="row flex-grow-1 align-items-center">
                                            {/* React-Select Dropdown */}
                                            <div className="col-12 col-sm-6 col-lg-4 mb-2 mb-sm-0">
                                                <Select
                                                    options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x, value: x } })]}
                                                    onChange={(event) => { setStatusType(event.value); }}
                                                    value={statusType !== "All" ? statusTypeArray.find(elem => elem.value == statusType) : { label: "All", value: "All" }}
                                                    placeholder="Select..."
                                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                />
                                            </div>
                                            <div className="col-12 col-sm-6 col-lg-4">
                                                <DateRangePickerComponent
                                                    ref={daterange_picker_ref}
                                                    allowEdit={false}
                                                    showClearButton={false}
                                                    focus={() => { daterange_picker_ref.current.show() }}
                                                    delayUpdate={true}
                                                    presets={[
                                                        { label: 'Today', start: new Date(), end: new Date() },
                                                        { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                        { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                        { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                                    ]}
                                                    change={(e) => {
                                                        setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                        setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                                    }}
                                                    startDate={new Date(startDate)}
                                                    endDate={new Date(endDate)}
                                                    max={new Date().toISOString().split('T')[0]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>
                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "45vh" }}>
                                            {
                                                ecommerceOrderReviewListApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    reviews.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                            <div className="row align-self-stretch">
                                                                {reviews.map((review, index) => (
                                                                    <div key={index} className="col-md-6 p-3">
                                                                        <div className="d-flex flex-column" style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", minHeight: "150px" }}>
                                                                            <div className="d-flex justify-content-between">
                                                                                <span className='fw-bold'>{review.account_name}</span>
                                                                                <Rating
                                                                                    initialRating={review.rating}
                                                                                    readonly
                                                                                    emptySymbol="far fa-star"
                                                                                    fullSymbol="fas fa-star"
                                                                                    style={{ color: "#fdbc0a" }}
                                                                                />
                                                                            </div>
                                                                            <span>{moment(review.add_date_time).format("ll")}</span>
                                                                            <div className="text-gray-600 fw-bold flex-grow-1 my-2">{review.review}</div>
                                                                            {/* <div className='text-end'><button className="btn btn-primary">Approve</button></div> */}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No reviews are available </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        state === 2 ?
                            <PageLoader />
                            :
                            <PageError />
                    }
                </div>
            </div>
        </>
    );
}
export default EcommerceOrderReviewList;